/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Preference_Offset_Out_Of_RangeInputs */

const en_us2_notification_preference_offset_out_of_range = /** @type {(inputs: Notification_Preference_Offset_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not read your device's time zone. Check the phone's clock settings.`)
};

const pt_br2_notification_preference_offset_out_of_range = /** @type {(inputs: Notification_Preference_Offset_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos ler o fuso horário do aparelho. Confira o relógio do celular.`)
};

const es_419_notification_preference_offset_out_of_range = /** @type {(inputs: Notification_Preference_Offset_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos leer la zona horaria de tu dispositivo. Revisa la configuración del reloj del teléfono.`)
};

const pt_pt2_notification_preference_offset_out_of_range = /** @type {(inputs: Notification_Preference_Offset_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos ler o fuso horário do dispositivo. Verifica as definições de hora do telemóvel.`)
};

const fr_fr2_notification_preference_offset_out_of_range = /** @type {(inputs: Notification_Preference_Offset_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de lire le fuseau horaire de ton appareil. Vérifie les réglages d'horloge du téléphone.`)
};

const de_de2_notification_preference_offset_out_of_range = /** @type {(inputs: Notification_Preference_Offset_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir konnten die Zeitzone deines Geräts nicht lesen. Prüf die Uhreinstellungen des Handys.`)
};

const it_it2_notification_preference_offset_out_of_range = /** @type {(inputs: Notification_Preference_Offset_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non siamo riusciti a leggere il fuso orario del dispositivo. Controlla le impostazioni dell'orologio del telefono.`)
};

/**
* | output |
* | --- |
* | "We could not read your device's time zone. Check the phone's clock settings." |
*
* @param {Notification_Preference_Offset_Out_Of_RangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const notification_preference_offset_out_of_range = /** @type {((inputs?: Notification_Preference_Offset_Out_Of_RangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Preference_Offset_Out_Of_RangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_notification_preference_offset_out_of_range(inputs)
	if (locale === "es-419") return es_419_notification_preference_offset_out_of_range(inputs)
	if (locale === "pt-PT") return pt_pt2_notification_preference_offset_out_of_range(inputs)
	if (locale === "fr-FR") return fr_fr2_notification_preference_offset_out_of_range(inputs)
	if (locale === "de-DE") return de_de2_notification_preference_offset_out_of_range(inputs)
	if (locale === "it-IT") return it_it2_notification_preference_offset_out_of_range(inputs)
	return en_us2_notification_preference_offset_out_of_range(inputs)
});
export { notification_preference_offset_out_of_range as "notification_preference.offset_out_of_range" }